module.exports = __webpack_public_path__ + "media/Video 141.6e0b02f4.mp4";